module.exports = __webpack_public_path__ + "fannie-mae-mockup@2x.2NRa3IzB.png";